import "./answerBox.css";
import { useMemo } from "react";

export default function AnswerBox({ answerResult, goToNextQuestion, question }) {
  const isCorrect = answerResult?.isCorrect || false;
  const selectedEverything = answerResult?.selectedEverything || false;
  const tooManyWrong = answerResult?.tooManyWrong || false;

  const required = question.answers || [];
  const alsoAcceptable = question.alsoAcceptable || [];

  const allCorrect = [...required, ...alsoAcceptable];

  const selectedTactics = answerResult?.selected || [];

  const correctSelected = allCorrect.filter(t => selectedTactics.includes(t));
  const missed = [];
  const extra = [...selectedTactics].filter(t => !allCorrect.includes(t));
  const missedOptional = [...alsoAcceptable, ...required].filter(t => !selectedTactics.includes(t));

  const hasExtrasButStillCorrect = isCorrect && extra.length > 0;
  const gotMajority = (required.length - missed.length) >= Math.ceil(required.length / 2);

  // subtext responses
  const correctResponses = [
    "You saw straight through that nonsense.",
    "Not even the sneaky ones got past you.",
    "The content tried... but you tried harder.",
    "Masterclass in digital deflection detection.",
    "Your inner cynic is thriving today.",
    "Detective mode: engaged.",
    "Insert victory dance here.",
    "Achievement unlocked: Critical Thinker III"
  ];

  const partialResponses = [
    "Good instincts, but a couple slipped past you.",
    "You’re halfway to digital Jedi.",
    "They almost got you… almost.",
    "Almost media literate.",
    "Just a few logical leaps from greatness.",
    "This result was generated using Random() hehe 🤫"
  ];

  const incorrectResponses = [
    "They had you going for a second. Let’s unpack it.",
    "That one was crafted to trick you, and it worked.",
    "Propaganda: 1. You: 0. But not for long.",
    "Consider this a speedrun in being misled.",
    "It’s okay. You’ve just been slightly bamboozled.",
    "Better luck next click."
  ];

  function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

const caption = useMemo(() => {
  const total = question.answers.length;
  const numCorrect = total - missed.length;

  if (selectedEverything) return "Did you just select... ALL of them? 😐";
  if (isCorrect) return pickRandom(correctResponses);
  if (numCorrect >= Math.ceil(total / 2) && extra.length <= 2) return pickRandom(partialResponses);
  return pickRandom(incorrectResponses);
}, [isCorrect, selectedEverything, missed, extra, question]);

  return (
    <div className="answerBoxContainer">
      <h2 className="answerBoxHeader">
                  {isCorrect ? (
          <span className="correctText">✅ CORRECT</span>
        ) : selectedEverything ? (
          <span className="incorrectText">😏 HAHA... NICE TRY</span>
        ) : tooManyWrong ? (
          <span className="incorrectText">❌ HMMM...</span>
        ) : gotMajority && extra.length <= 2 ? (
          <span className="partialText">🧐 ALMOST THERE</span>
        ) : (
          <span className="incorrectText">❌ HMMM...</span>
        )}
      </h2>

      <h3 className="answerBoxSubtext">{caption}</h3>

      {hasExtrasButStillCorrect && (
        <p className="tacticWarning">
          You earned the point, but you also flagged some extra tactics that weren't used. Be careful — overflagging analysts are the first to be recalibrated 🤖
        </p>
      )}

      <div className="answerBoxContentScroll">

        {/* correct */}
        {correctSelected.length > 0 && (
          <div className="tacticGroup correctGroup">
            <h3>What you got right:</h3>
            {correctSelected.map((tactic) => (
              <p key={tactic} className="tacticExplanation correctExplanation">
                ✅ {tactic}: {question.tacticExplanations?.[tactic] || "(no explanation provided)"}
              </p>
            ))}
          </div>
        )}

        {/* missed */}
        {missed.length > 0 && (
          <div className="tacticGroup missed">
            <h3>You missed:</h3>
            {missed.map((tactic) => (
              <p key={tactic} className="tacticExplanation missing">
                ⚠️ {tactic}: {question.tacticExplanations?.[tactic] || "(no explanation provided)"}
              </p>
            ))}
          </div>
        )}

        {/* wrong */}
        {extra.length === selectedTactics.length && correctSelected.length === 0 && (
          <p className="tacticWarning">
            You didn't identify any tactics correctly this round. Try reading the post again more carefully next time 👀
          </p>
        )}
      
        {/* could also add stuff */}
        {missedOptional.length > 0 && (
          <div className="tacticGroup bonus">
            <h3>You could have chosen:</h3>
            {missedOptional.map((tactic) => (
              <p key={tactic} className="tacticExplanation bonusTactic">
                💭 {tactic}: {question.tacticExplanations?.[tactic] || "(no explanation provided)"}
              </p>
            ))}
          </div>
        )}

      
      </div>


      <button className="nextQuestionButton" onClick={goToNextQuestion}>NEXT</button>
    </div>
  );
}
